export default __webpack_public_path__ + "static/media/exit.9ab5df97.svg";